export const GeneratorExperiment = Object.freeze({
  'Old': 21,
  'New': 28,
  'AI': '30',
  'Alg100': '100',
})
